import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailDisplayComponent } from './detail-display/detail-display.component';
import { DsColComponent } from './ds-col/ds-col.component';

@NgModule({
  declarations: [DetailDisplayComponent, DsColComponent],
  imports: [CommonModule],
  exports: [DetailDisplayComponent, DsColComponent],
})
export class BasicModule {}
